AoPS.Utils.initKeyChain(AoPS, "KeepLearning", "Views");

AoPS.KeepLearning.Views = (function (Views) {
	Views.Index = AoPS.View.extend({
		template_id: "#keeplearning-tpl-tabs",
		className: "keeplearning-tabs",
		initialize: function () {
			var tabContent = this.model.get("tab_content");
			this.vars = {
				puzzles: tabContent["puzzles"],
				aopsResources: tabContent["aops_resources"],
				beastAcademy: tabContent["beast_academy"],
			};

			this.render();
			var self = this;
			setTimeout(function () {
				self.handleLocationHash();
				$(window).scrollTop(0);
			}, 1);
		},
		render: function () {
			var keepLearningTpl = this.getTemplate(this.template_id, this.vars);

			var Index = this;
			this.$el.html(keepLearningTpl);
			setTimeout(function () {
				$(".keeplearning-tabs .tab").on("click", Index.handleTabs);
				$(window).on("hashchange", Index.handleLocationHash);
			}, 0);
		},
		handleTabs: function (e) {
			var activeTab = $("#" + e.target.id + "-content");
			$(".tab-contents .active").hide();
			$(".tab-wrapper .active").removeClass("active");
			activeTab.addClass("active");
			activeTab.show();
			$(e.target).addClass("active");
			if (location.hash !== "#" + e.target.id) {
				history.replaceState(history.state, "", "#" + e.target.id);
			}
		},
		handleLocationHash: function () {
			if (location.hash) {
				var hash = location.hash;

				var match = hash.match(/^#[A-Za-z0-9-_]*/);
				if (match && match.length) {
					hash = match[0];
				}

				if (hash === "#") {
					return;
				}

				var $anchor = $(document).find(hash);
				if ($anchor.length) {
					if (hash === "#circlechallenge") {
						// special handling for #circlechallenge - https://bugs.aops.com/T61883
						this.scrollTo($anchor);
					} else {
						$anchor.click();
					}
				}
			}
		},
		scrollTo($el) {
			// wait until everything is done loading
			// before calculating position and scrolling
			if (document.readyState === "complete") {
				// do scrolling
				var scrollPadding = 150; // arbitrary padding so desired element does not sit right against header
				$(window).scrollTop($el.offset().top - scrollPadding);
			} else {
				setTimeout(_.bind(this.scrollTo, this), 10, $el);
			}
		},
	});

	return Views;
})(AoPS.KeepLearning.Views || {});
